// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__2gEKX","description":"style_description__e2CZ6","actions":"style_actions__mYydO","actions_btn":"style_actions_btn__-LZq0"};